<template lang="pug">
  footer#the-footer: .container
    .dev-panel(v-if="false")
      button(@click="goPrev") <<
      button(@click="goNext") >>
</template>

<script>
// TODO: Describe visibility of the dev-panel while production
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'TheFooter',
  // Computed ------------------------------------------------------------------
  computed: {
    // Vuex map getters of the Wizard SM
    ...mapGetters('moduleWizard', [
      'getNextStepName',
      'getPrevStepName'
    ])
  },
  // Methods -------------------------------------------------------------------
  methods: {
    // Vuex map mutations of the Wizard SM
    ...mapMutations('moduleWizard', [
      'UNLOCK_STEP_SWITCH'
    ]),
    goPrev () {
      this.UNLOCK_STEP_SWITCH()
      this.$router.push({ name: this.getPrevStepName })
    },
    goNext () {
      this.UNLOCK_STEP_SWITCH()
      this.$router.push({ name: this.getNextStepName })
    }
  }
}
</script>
